import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { kekaSchema } from "./schema";
import { useCreateKeka } from "../create/mutation";

export const useKekaForm = () => {
  const form = useForm({
    resolver: zodResolver(kekaSchema),
    defaultValues: {
      client_id: "",
      client_secret: "",
      api_key: "",
      base_url: "",
    },
  });

  const createKeka = useCreateKeka();

  const handleCreate = async (context) => {
    const item = context.values;
    await createKeka.mutateAsync({ item });
  };

  return {
    form,
    handleCreate,
  };
};
